module.exports = __webpack_public_path__ + "static/confirm-reservation-88c458543842947f6094c62624dd7483.jpg";